import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/layout/PageHeader';
import { pageDescriptions } from '../data/pageDescriptions';

const PrivacyPolicy = () => {
  const copy = pageDescriptions['/privacy-policy'];
  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <PageHeader
          title={copy.title}
          description={`${copy.description} Last updated: May 4, 2025.`}
        />
        <div className="card overflow-hidden">
          <div className="px-4 py-5 sm:p-6 prose max-w-none">
            <p className="text-gray-700">
              This Privacy Policy describes how Your Extension Name ("we", "our", or "us") collects, uses, and shares information in connection with your use of our browser extension.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 pb-2 border-b border-gray-200">Information We Collect</h2>
            <p className="text-gray-700">Our extension collects the following information:</p>
            <ul className="text-gray-700 list-disc pl-5 space-y-1">
              <li className="mt-2">
                <span className="font-medium">Account information:</span> When you create an account, we collect your email address and password to authenticate your identity.
              </li>
              <li className="mt-2">
                <span className="font-medium">Job posting data:</span> When you use our extension to save job listings, we collect information from the job posting page such as job title, company name, job description, and URL.
              </li>
              <li className="mt-2">
                <span className="font-medium">Usage data:</span> We collect anonymous usage data to improve our extension, such as which features are most commonly used.
              </li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 pb-2 border-b border-gray-200">How We Use Your Information</h2>
            <p className="text-gray-700">We use the information we collect to:</p>
            <ul className="text-gray-700 list-disc pl-5 space-y-1">
              <li>Provide and maintain our service</li>
              <li>Authenticate your identity and maintain your account</li>
              <li>Store job postings you've saved</li>
              <li>Improve and optimize our extension</li>
              <li>Respond to your requests and provide customer support</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 pb-2 border-b border-gray-200">Data Storage and Security</h2>
            <p className="text-gray-700">
              We use industry-standard security measures to protect your data. Your personal information is stored in secure databases and is only accessible to authorized personnel. We use HTTPS encryption to protect data in transit.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 pb-2 border-b border-gray-200">Data Sharing</h2>
            <p className="text-gray-700">
              We do not sell your personal information to third parties. We may share your information in the following circumstances:
            </p>
            <ul className="text-gray-700 list-disc pl-5 space-y-1">
              <li>With service providers who help us operate our extension</li>
              <li>If required by law or to protect our rights</li>
              <li>In connection with a business transfer (such as a merger or acquisition)</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 pb-2 border-b border-gray-200">Your Rights</h2>
            <p className="text-gray-700">You have the right to:</p>
            <ul className="text-gray-700 list-disc pl-5 space-y-1">
              <li>Access and download your personal data</li>
              <li>Correct inaccurate information</li>
              <li>Delete your account and associated data</li>
              <li>Opt out of certain data collection</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 pb-2 border-b border-gray-200">Cookies and Local Storage</h2>
            <p className="text-gray-700">
              Our extension uses browser storage to remember your preferences and keep you logged in. This data remains on your device and is not transmitted to our servers unless necessary for synchronizing your account.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 pb-2 border-b border-gray-200">Children's Privacy</h2>
            <p className="text-gray-700">
              Our service is not directed to individuals under the age of 16. We do not knowingly collect personal information from children under 16.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 pb-2 border-b border-gray-200">Changes to This Privacy Policy</h2>
            <p className="text-gray-700">
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 pb-2 border-b border-gray-200">Contact Us</h2>
            <p className="text-gray-700">
              If you have any questions about this Privacy Policy, please contact us at:{' '}
              <a href="mailto:marketing@myresumemo.com" className="text-primary-600 hover:text-primary-500">
                your.email@example.com
              </a>
            </p>
            
            <div className="mt-8 pt-6 border-t border-gray-200">
              <Link to="/" className="text-primary-600 hover:text-primary-500 font-medium">
                ← Back to home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;